var WDN = WDN || {};

if (typeof WDN.MobileMenu === "undefined") {
  WDN.MobileMenu = (function () {
    var init;
    var onCartClick;

    // Depends on
    var SectionRenderer = WDN.SectionRenderer;

    // Returned instances
    var Renderer, Slides;

    // Nodes
    var nodes = {
      cartTrigger: false,
    };

    // Handles cart trigger click inside mobile menu
    onCartClick = function () {
      WDN.CartDrawer.refresh();
      nodes.cartTrigger.removeEventListener("click", onCartClick);
    };

    init = function () {
      Renderer = new SectionRenderer({
        selectors: {
          trigger: "wdn-drawer-open[data-id='menu']",
          output: "[data-mobilemenu-content]",
        },
        sections: ["async-mobile-menu"],
        events: ["click"],
        callback: function () {
          // Setup of slides
          WDN.MobileMenu.Slides = new WDN.Slides({
            group: "mobilemenu",
          });

          // Setup of country select
          if (!WDN.CountrySelect.Renderer.complete) {
            WDN.CountrySelect.Renderer.reinit();
          }
        },
      });

      // Callback to SectionRenderer - fired before the request is sent
      Renderer.onInteraction = function () {
        // Load stylesheet
        WDN.StylesheetLoader.load(".mobilemenu-style");
      };

      // Listen for drawer close
      document.body.addEventListener("overlay:closed", function (e) {
        if (e.detail.id !== "menu") return;
        // Select back arrow
        var backArrow = document.querySelector("[data-slide-to='back'][data-slide-group='mobilemenu']");

        // Select scroll container inside the drawer
        var scrollableContent = document.querySelector("[data-menu-scroll]");

        // Slide back to initial state (400ms delay for animation to finish)
        setTimeout(function () {
          // Set scroll position to top
          if (scrollableContent) {
            scrollableContent.scroll(0, 0);
          }

          // Reset slides positions by clicking first back arrow
          if (backArrow) {
            backArrow.click();
          }
        }, 400);
      });
    };

    // Init
    init();
    return {
      Renderer,
      Slides,
    };
  })();
}
